import { jsx as _jsx } from "react/jsx-runtime";
import { useOwnerBranding } from '../branding.js';
/**
 * Owner brand mark — placed in the top-left of every template so the
 * rendered PDF carries the operating owner's identity. Reads the active
 * owner from `OwnerBrandingProvider`; falls back to the owner name as
 * text when no logo URL is set, and renders nothing when no provider is
 * mounted at all (e.g. an isolated render in tests).
 */
export function OwnerLogo(props) {
    const branding = useOwnerBranding();
    if (!branding)
        return null;
    const maxHeight = props.maxHeight ?? '1.2cm';
    const maxWidth = props.maxWidth ?? '5cm';
    if (branding.logoUrl) {
        return (_jsx("img", { src: branding.logoUrl, alt: branding.name, className: "object-contain", style: { maxHeight, maxWidth } }));
    }
    return (_jsx("span", { className: "text-[10px] font-semibold uppercase tracking-[0.15em] text-stone-700", children: branding.name }));
}
//# sourceMappingURL=OwnerLogo.js.map